import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ToastrModule } from 'ngx-toastr';
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { GoogleMapsComponent } from '@sharedComponents/google-maps/google-maps.component';
import { AgmCoreModule } from '@agm/core';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxSpinnerModule } from 'ngx-spinner';
import { environment } from '@environment';
import { ButtonDirective } from './directives/button.directive'
import { DatetimepickerComponent } from './components/datetimepicker/datetimepicker.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input'
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CompressEncodeImagePipe } from '@sharedPipes/compress-encode-image.pipe';
import { RemoveDuplicateFilesPipe } from '@sharedPipes/remove-duplicate-files.pipe';
import { DateRangePickerComponent } from '@sharedComponents/dateRangepicker/dateRangePicker.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DebounceKeyupDirective } from './directives/debounce-keyup.directive';
import { DebounceClickDirective } from './directives/debounce-click.directive';
import { TermsOfServiceComponent } from '@sharedComponents/terms-of-service/terms-of-service.component';
import { SearchFilterPipe } from './pipes/search-filter.pipe';
import { SearchByMobileEmailWsnComponent } from './components/search-by-mobile-email-wsn/search-by-mobile-email-wsn.component';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { ChangePasswordComponent } from '@sharedComponents/change-password/change-password.component';
import { LoadDialogComponent } from './components/load-dialog/load-dialog.component';
import { ConvertCasePipe } from './pipes/convert-case.pipe';
import { DecodeImagePipe } from '@sharedPipes/decode-image.pipe';
import { EncodeFilePipe } from '@sharedPipes/encode-file.pipe';
import { DecodeFilePipe } from '@sharedPipes/decode-file.pipe';
import { SafePipe } from '@sharedPipes/safe.pipe';
import { ConfirmationComponent } from '@sharedComponents/confirmation/confirmation.component';
import { TransformTextPipe } from './pipes/transform-text.pipe';
import { CustomerHospitalFilterComponent } from './components/customer-hospital-filter/customer-hospital-filter.component'
import { MatSelectModule } from '@angular/material/select';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { UpdateProfileDialogComponent } from './components/my-profile/update-profile-dialog/update-profile-dialog.component';
import { UpdateEmergencyDetailsDialogComponent } from './components/my-profile/update-emergency-details-dialog/update-emergency-details-dialog.component';
import { ViewFileComponent } from './components/view-file/view-file.component'
import { ProfileHeaderComponent }  from './components/profile-header/profile-header.component'
import { TransactionDetailsComponent } from './components/transaction-details/transaction-details.component';
import { ProductTypePipe } from './pipes/product-type.pipe'
import { UploadFileByChunksComponent } from './components/upload-file-by-chunks/upload-file-by-chunks.component'
import { ReadMoreLessComponent }  from './components/read-more-less/read-more-less.component'
import { LoadingBarComponent } from './components/loading-bar/loading-bar.component';
import { VerifyPasswordComponent } from './components/verify-password/verify-password.component';
import { DisplayDataComponent } from './components/display-data/display-data.component'
import { MultiSelectHospitalComponent } from './components/multi-select-hospital/multi-select-hospital.component'
@NgModule({
  declarations: [
    GoogleMapsComponent,
    ButtonDirective,
    DatetimepickerComponent,
    CompressEncodeImagePipe,
    RemoveDuplicateFilesPipe,
    DateRangePickerComponent,
    DebounceKeyupDirective,
    DebounceClickDirective,
    TermsOfServiceComponent,
    SearchFilterPipe,
    SearchByMobileEmailWsnComponent,
    DateRangeComponent,
    ConvertCasePipe,
    ChangePasswordComponent,
    LoadDialogComponent,
    DecodeImagePipe,
    EncodeFilePipe,
    DecodeFilePipe,
    SafePipe,
    ConfirmationComponent,
    TransformTextPipe,
    CustomerHospitalFilterComponent,
    MyProfileComponent,
    UpdateEmergencyDetailsDialogComponent,
    UpdateProfileDialogComponent,
    ProfileHeaderComponent,
    ReadMoreLessComponent,
    TransactionDetailsComponent,
    ProductTypePipe,
    UploadFileByChunksComponent,
    LoadingBarComponent,
    ViewFileComponent,
    ReadMoreLessComponent,
    UploadFileByChunksComponent,
    VerifyPasswordComponent,
    DisplayDataComponent,
    MultiSelectHospitalComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatAutocompleteModule,
    FormsModule,
    ToastrModule.forRoot({
      timeOut: 1500,
      preventDuplicates: true,
      maxOpened: 4,
      autoDismiss: true,
      enableHtml: true
    }),
    AgmCoreModule.forRoot({
      apiKey: environment.googleMaps_api_key,
      libraries: ['places']
    }),
    MatDialogModule,
    NgxSpinnerModule,
    MatFormFieldModule,
    NgxMaterialTimepickerModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule
  ],
  exports: [
    ButtonDirective,
    DebounceKeyupDirective,
    DebounceClickDirective,
    DatetimepickerComponent,
    SearchByMobileEmailWsnComponent,
    DateRangeComponent,
    ChangePasswordComponent,
    GoogleMapsComponent,
    DateRangePickerComponent,
    TransformTextPipe,
    SearchFilterPipe,
    ConvertCasePipe,
    SafePipe,
    CustomerHospitalFilterComponent,
    LoadingBarComponent,
    ReadMoreLessComponent,
    ViewFileComponent,
    ProductTypePipe,
    VerifyPasswordComponent,    
    DisplayDataComponent,
    MultiSelectHospitalComponent
  ],
  providers: [
    CompressEncodeImagePipe,
    ConvertCasePipe,
    DecodeFilePipe,
    DecodeImagePipe,
    EncodeFilePipe,
    RemoveDuplicateFilesPipe,
    SafePipe,
    SearchFilterPipe,
    TransformTextPipe,
    ProductTypePipe
  ]
})

export class SharedModule {}
